
const overview = resolve => require(['@/components/orderNewPurchase/overview'],resolve);
const goodsCompare = resolve => require(['@/components/orderNewPurchase/goodsCompare'],resolve);
const bandAnalysis = resolve => require(['@/components/orderNewPurchase/band'],resolve);
const structureCategory = resolve => require(['@/components/orderNewPurchase/structureCategory'],resolve);
const sizeModel = resolve => require(['@/components/orderNewPurchase/sizeModel'],resolve);
const tagSkc = resolve => require(['@/components/orderNewPurchase/tagSkc'],resolve);
const kjTag = resolve => require(['@/components/orderNewPurchase/kjTag'],resolve);
const areaOrderRank = resolve => require(['@/components/orderNewPurchase/areaOrderRank'],resolve);
const bandColor = resolve => require(['@/components/orderNewPurchase/bandColor'],resolve);
const price = resolve => require(['@/components/orderNewPurchase/price'],resolve);
const mainPush = resolve => require(['@/components/orderNewPurchase/mainPush'],resolve);
const topSkc = resolve => require(['@/components/orderNewPurchase/topSkc'],resolve);
export default [
	{
		path : 'orderNewPurchase/overview',
		name : 'overviewPurchase',
		meta : {
			title : '整体概况',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : overview
	},
	{
		path : 'orderNewPurchase/compare',
		name : 'goodsComparePurchase',
		meta : {
			title : '两年对比',
			searchDisabled : true,
			notNeedGlobalScroll : false
		},
		component : goodsCompare
	},
	{
		path : 'orderNewPurchase/band',
		name : 'bandAnalysisPurchase',
		meta : {
			title : '波段指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : bandAnalysis
	},
	{
		path : 'orderNewPurchase/sizeModel',
		name : 'sizeModelDistributionPurchase',
		meta : {
			title : '尺码指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : sizeModel
	},
	{
		path : 'orderNewPurchase/kjTag',
		name : 'kjTagPurchase',
		meta : {
			title : '框架款指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : kjTag
	},
	{
		path : 'orderNewPurchase/areaOrderRank',
		name : 'areaOrderRankPurchase',
		meta : {
			title : '区域订量排名',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : areaOrderRank
	},
	{
		path : 'orderNewPurchase/tag',
		name : 'tagSkcPurchase',
		meta : {
			title : '标签指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : tagSkc
	},
	{
		path : 'orderNewPurchase/bandColor',
		name : 'bandColorPurchase',
		meta : {
			title : '色系指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : bandColor
	},
	{
		path : 'orderNewPurchase/price',
		name : 'priceDistributionPurchase',
		meta : {
			title : '价格指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : price
	},
	{
		path : 'orderNewPurchase/structureCategory',
		name : 'structureCategoryPurchase',
		meta : {
			title : '品类指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : structureCategory
	},
	{
		path : 'orderNewPurchase/mainPush',
		name : 'mainPushPurchase',
		meta : {
			title : '主推爆杆',
			searchDisabled : true,
			notNeedGlobalScroll : false
		},
		component : mainPush
	},
	{
		path : 'orderNewPurchase/topSkc',
		name : 'topSkcPurchase',
		meta : {
			title : 'TOP指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : topSkc
	},
]



// WEBPACK FOOTER //
// ./src/router/orderNewPurchase/index.js